import common from "./module/common";
import undefined from "./module/undefined";
import login from "./module/login";
import register from "./module/register";
import forget from "./module/forget";
import reset from "./module/reset";
import account from "./module/account";
import index from "./module/index";
import enroll from "./module/enroll/index";
import verify from "./module/verify";
import invoice from "./module/invoice";
import feeLetter from "./module/feeLetter";
import home from "./module/home";
import creation from "./module/creation";
import notPaid from "./module/notPaid";
import payment from "./module/payment";

export default {
  common: common.en,
  undefined: undefined.en,
  login: login.en,
  register: register.en,
  forget: forget.en,
  reset: reset.en,
  account: account.en,
  index: index.en,
  enroll: enroll.en,
  verify: verify.en,
  invoice: invoice.en,
  feeLetter: feeLetter.en,
  home: home.en,
  creation: creation.en,
  notPaid: notPaid.en,
  payment: payment.en,
};
